module.exports = __webpack_public_path__ + "img/mail.51c44790.svg";